import { useEffect, useState } from "react";

export function useMousePosition() {
  const [mousePosition, setMousePosition] = useState<[number, number]>([0, 0]);
  function onMoveMouse(event: PointerEvent) {
    setMousePosition([event.clientX, event.clientY]);
  }

  useEffect(() => {
    globalThis.addEventListener("pointermove", onMoveMouse);
    return () => globalThis.removeEventListener("pointermove", onMoveMouse);
  }, []);

  return mousePosition;
}
